import { deserialize as deserializeMetricResponse } from 'cio/utils/metrics/deserialize/metric';
import { Entities, Periods } from 'cio/utils/metrics/common';
import { Metric } from 'cio/utils/metrics/models/metric';
import { Grouping } from '../resolution';

export function deserialize(
  data: any,
  meta?: { environmentId?: number | string; campaignId?: number | string; newsletterId?: number | string },
): null | Metric[] {
  return data.metrics.map((metric: any) =>
    deserializeMetricResponse(
      { metric },
      Entities.TEMPLATE,
      metric.template_id,
      Periods.DAYS,
      Grouping.Daily,
      Periods.DAYS,
      null,
      null,
      metric.type,
      meta,
    ),
  );
}
